import { useDonationFormTranslationField } from "@/hooks/useDonationTranslation";
import { useTranslate } from "@/hooks/useTranslate";
import { DonationFormFrontendPageOutput } from "@/types/trpc";

export type DonationFormMetaContentType = "donationForm" | "p2p" | "team";

export const useDonationFormMetaContent = ({
  donationForm,
  metaContentType,
  title,
}: {
  donationForm: DonationFormFrontendPageOutput;
  title: string | undefined;
  metaContentType: DonationFormMetaContentType;
}): {
  metaTitle: string | undefined;
  metaDescription: string | undefined;
} => {
  const { t } = useTranslate();
  const { donationFormField: campaignFormField } = useDonationFormTranslationField(donationForm);

  switch (metaContentType) {
    case "p2p":
      return {
        metaTitle: t("common", "header.p2p.title", {
          campaignTitle: title,
          orgName: donationForm?.organization?.name,
        }),
        metaDescription: t("common", "header.p2p.description", {
          campaignTitle: title,
          orgName: donationForm?.organization?.name,
        }),
      };

    case "team":
      return {
        metaTitle: t("common", "header.team.title", {
          teamName: title,
          campaignTitle: campaignFormField?.title || donationForm?.organization?.name,
          orgName: donationForm?.organization?.name,
        }),
        metaDescription: t("common", "header.team.description", {
          teamName: title,
          campaignTitle: campaignFormField?.title || donationForm?.organization?.name,
          orgName: donationForm?.organization?.name,
        }),
      };

    case "donationForm":
      return {
        metaTitle: t("common", "header.donationForm.title", {
          orgName: donationForm?.organization?.name,
          formTitle: title,
        }),
        metaDescription: t("common", "header.donationForm.description", {
          orgName: donationForm?.organization?.name,
          formTitle: title,
        }),
      };
  }
};
